<template>
  <div class="page-header">
    <div class="logo-desc">
      <img
        class="ydb-logo"
        width="82"
        height="30"
        src="../../assets/page-header/logo.png"
        alt="logo"
      />
    </div>
    <ul class="menu">
      <li class="menu-item user">
        <i class="icon account"></i>
        <span class="menu-name">用户</span>
        <div class="container">
          <ul class="user-list">
            <li>
              <span>{{ userName }}</span>
            </li>
            <li @click="goToAccount">
              <svg
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="1353"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="22"
                height="22"
              >
                <path
                  d="M621.8 601.2c86.8-49.5 146.1-141.9 146.1-249 0-158.9-128.8-287.7-287.7-287.7S192.5 193.3 192.5 352.2c0 107.1 59.2 199.5 146.1 249-150 54.5-259.7 192.7-272.3 358.3h63.9c16.2-178.9 166.9-319.6 350-319.6s333.8 140.7 350 319.6h63.9c-12.6-165.6-122.3-303.8-272.3-358.3z m-365.4-249c0-123.4 100.4-223.7 223.8-223.7S704 228.8 704 352.2 603.6 575.9 480.2 575.9 256.4 475.6 256.4 352.2z"
                  p-id="1354"
                  fill="#ffffff"
                />
              </svg>
              <span>我的账号</span>
            </li>
            <li @click="loginout">
              <svg
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="1856"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="22"
                height="22"
              >
                <path
                  d="M704.3 129.9v78.7c78 64.5 127.7 161.8 127.7 270.7 0 193.6-157.5 351.2-351.2 351.2S129.7 672.9 129.7 479.3c0-108.8 49.8-206.2 127.7-270.7v-78.7C142.3 203.7 65.9 332.4 65.9 479.3c0 229.2 185.8 415 415 415s415-185.8 415-415c0-146.9-76.5-275.6-191.6-349.4z"
                  p-id="1857"
                  fill="#ffffff"
                />
                <path d="M448.9 64.3h63.8v446.9h-63.8z" p-id="1858" fill="#ffffff" />
              </svg>
              <span>退出登录</span>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script >
// import storage from "good-storage";
import { deleteToken, getSupplierName } from "common/js/storage";
import DBUser from "models/db/user.js";
const dbUser = new DBUser();
export default {
  data() {
    return {
      userName: ""
    };
  },
  beforeMount() {
    this.userName = getSupplierName();
  },
  methods: {
    // 前往我的账号
    goToAccount() {
      this.$router.push("/supplier/spl-account/account-update");
    },
    // 退出登录
    loginout() {
      deleteToken();
      this.$router.push("/supplier/spl-user/spl-login");
    }
  }
};
</script>

<style lang="scss" scoped>
.page-header {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #233446;
  padding: 17px 20px;
  box-sizing: border-box;
  letter-spacing: 1px;
  .logo-desc {
    display: flex;
    flex-direction: row;
    align-items: center;
    .desc {
      margin-left: 16px;
      width: 126px;
      height: 28px;
      line-height: 28px;
      font-size: 20px;
      font-family: "PingFangSC-Medium";
      color: rgba(192, 196, 204, 1);
    }
  }
  .menu {
    display: flex;
    flex-direction: row;
    padding-right: 40px;
    .menu-item {
      margin-left: 24px;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      .icon {
        width: 24px;
        height: 24px;
        margin-right: 6px;
      }
      .message {
        background-image: url("../../assets/page-header/message@1x.png");
        background-size: cover;
      }
      .account {
        background: url("../../assets/page-header/account@1x.png");
        background-size: cover;
      }
      .mall {
        background: url("../../assets/page-header/mall@1x.png");
        background-size: cover;
      }
      .menu-name {
        width: 26px;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        font-family: "PingFangSC-Regular";
        color: rgba(255, 255, 255, 1);
      }
    }
    .user {
      position: relative;
      .container {
        display: none;
        z-index: 10000;
        position: absolute;
        left: -42px;
        width: 150px;
        height: 150px;
        top: 0;
        padding-top: 46px;
        .user-list {
          width: 150px;
          height: 132px;
          background: #233446;
          display: flex;
          flex-direction: column;
          border-radius: 5px;
          box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          li {
            flex: 1;
            color: #fff;
            padding-left: 20px;
            display: flex;
            align-items: center;
            font-size: 14px;
            span {
              padding-left: 8px;
            }
          }
          li:first-child:hover {
            background: #233446;
            cursor: default;
          }
          li:hover {
            background: #3d74f2;
            cursor: pointer;
          }
        }
      }
    }
    .user:hover {
      .container {
        display: block;
      }
    }
  }
}
</style>
